import type { FC } from 'react';
import { RefreshCw, AlertCircle } from 'lucide-react';

export const ErrorPage: FC = () => (
  <div className="flex h-full flex-col items-center justify-center p-8 text-center">
    <AlertCircle className="h-12 w-12 text-destructive" />
    <h1 className="mt-4 text-2xl font-bold text-foreground">Something went wrong</h1>
    <p className="mt-2 text-muted-foreground">
      An unexpected error occurred. Please try reloading the page.
    </p>
    <button
      onClick={() => window.location.reload()}
      className="mt-6 inline-flex items-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90 focus:ring-2 focus:ring-ring focus:ring-offset-2 focus:outline-none"
    >
      <RefreshCw className="mr-2 h-4 w-4" />
      Reload
    </button>
  </div>
);
